import { useState } from "react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { getStoredAffiliateCode } from "@/hooks/useAffiliateTracking";

interface StripeButtonWithCountriesProps {
  productType: "3months" | "6months" | "12months" | "test1euro" | "monthly";
  children: React.ReactNode;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "vip";
}

const StripeButtonWithCountries = ({ 
  productType, 
  children, 
  className, 
  size = "lg", 
  variant = "default" 
}: StripeButtonWithCountriesProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = async () => {
    setIsLoading(true);

    try {
      const affiliateCode = getStoredAffiliateCode() || '';

      const { data, error } = await supabase.functions.invoke('create-stripe-session', {
        body: {
          productType,
          affiliateCode,
        }
      });

      if (error) {
        console.error("Erreur Supabase:", error);
        throw new Error(error.message);
      }

      if (!data?.success || !data?.url) {
        throw new Error(data?.error || "Erreur lors de la création de la session");
      }

      window.location.href = data.url;
      
    } catch (error) {
      console.error("Erreur paiement:", error);
      toast.error("Erreur lors du paiement. Veuillez réessayer.");
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleButtonClick}
      className={className}
      size={size}
      variant={variant}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Redirection vers le paiement...
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default StripeButtonWithCountries;
